import { AfterViewInit, Component, ElementRef, Injector, NgZone, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import { WebcomponentsService } from '@core/service/webcomponents.service';
import { MarketingEventEnumeration, MarketingEventService } from '@shared/services';
import { show_popup } from '@shared/utility/popup-error';

import { CHECK_PROCESS_STATE_ENUMERATION, checkProcessRedirect } from '@core/configs/check-process';
import { SCREEN_TYPE_CONSTANTS } from '@core/model/enums';
import { ROUTES_CONSTANTS } from '@shared/configs';

@Component({
  selector: 'sign-application',
  templateUrl: './sign-application.component.html',
})
export class SignApplicationComponent implements AfterViewInit {
  @ViewChild('applicationSignatureRef') public applicationSignatureRef: ElementRef;
  public applicationSignatureRefInstance: { build: Function; destroy: Function };

  private readonly authService: AuthService;
  private readonly webElementService: WebcomponentsService;
  private readonly router: Router;
  private readonly ngZone: NgZone;
  private readonly marketingEventService: MarketingEventService;

  constructor(private readonly injector: Injector) {
    this.authService = this.injector.get(AuthService);
    this.webElementService = this.injector.get(WebcomponentsService);
    this.router = this.injector.get(Router);
    this.ngZone = this.injector.get(NgZone);
    this.marketingEventService = this.injector.get(MarketingEventService);
  }

  public ngAfterViewInit(): void {
    this.loadApplicationSignatureRef();
  }

  public loadApplicationSignatureRef(): void {
    this.webElementService.isLoaded$.pipe(filter(Boolean), take(1)).subscribe({
      next: () => {
        const token = this.authService.token;
        const payload = this.authService.getTokenData(token);

        this.applicationSignatureRefInstance =
          this.applicationSignatureRef.nativeElement._ngElementStrategy?.componentRef.instance;
        this.applicationSignatureRefInstance.build({
          clientId: payload.clienteId,
          cancelApplicationModalActionFn: this.redirectToHome.bind(this),
          continueActionFn: this.redirectToHomeAndTagEvents.bind(this),
          alternativeNavigationFn: this.alternativeNavigation.bind(this),
        });
      },
    });
  }

  private redirectToHome(): void {
    this.ngZone.run(() => {
      this.router.navigate(['/home']);
    });
  }

  private redirectToHomeAndTagEvents(event): void {
    const responseMessage = event?.response?.message;

    if (responseMessage === 'El código de firma no coincide') {
      show_popup('Error', 'El código de firma no coincide. Por favor, inténtalo de nuevo.');
    } else {
      this.ngZone.run(() => {
        this.marketingEventService.sendMarketingEvents(MarketingEventEnumeration.LOAN_APPLICATION_APPROVED_RFYA);
        this.router.navigate([ROUTES_CONSTANTS.APPLICATION_STATUS], {
          queryParams: { screenType: SCREEN_TYPE_CONSTANTS.CONGRATULATIONS },
        });
      });
    }
  }

  private alternativeNavigation({ state }): void {
    this.ngZone.run(() => {
      const route = checkProcessRedirect(state, [CHECK_PROCESS_STATE_ENUMERATION.PENDING_SIGNATURE]);
      if (route) {
        this.router.navigate([route]);
      }
    });
  }
}
